import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { I18nService } from "src/app/shared/i18n/service/i18n.service";
import { MaterialModule } from "src/app/shared/module/material.module";

@Component({
  selector: "rfc-array-column",
  templateUrl: "./array-column.component.html",
  styleUrls: ["./array-column.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule
  ]
})
export class ArrayColumnComponent implements OnChanges {
  @Input() arrayInput;
  @Input() labelInput;
  residues;
  constructor(private i18n: I18nService) {}

  ngOnChanges(changes: SimpleChanges) {}

  getElementToShow(arrayEl, index) {
    if (index <= 1) {
      this.residues = this.arrayInput.length - (index + 1);
      return arrayEl;
    }
  }
  getMoreElementToDisplayCondition() {
    return this.arrayInput.length > 2;
  }

  getLabel() {
    return `+ ${this.residues} ${this.getLabelComponent()}`;
  }

  getLabelComponent() {
    switch (this.labelInput) {
      case "other_recipient":
        return this.residues === 1
          ? this.i18n.getTranslation("other_recipient")
          : this.i18n.getTranslation("others_recipient");
    }
  }
}
